/* eslint-disable camelcase */
export default {
  sponsor_flag: "(SP)",
  select_leg: "Select leg",
  left_leg: "Left leg",
  right_leg: "Right leg",
  unknown_error: "Unexpected error fetching downline!",
};
